var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',[_vm._v("Officers & Staff")]),_c('div',{staticClass:"contentGrid"},_vm._l((_vm.staff),function(member){return _c('StaffMember',{key:member.title,attrs:{"member":member}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }